/** Spanish for the My Hub hub area. Keys are the exact English strings the UI renders. */
const hub = {
  // Navigation + page header (data/navigation.js, pages/MyHub.js)
  'My Hub': 'Mi centro',
  'Your clinics, and what each one can do.': 'Sus clínicas y lo que cada una puede hacer.',
  'What your clinic can do, as set by your sales representative.':
    'Lo que su clínica puede hacer, según lo configuró su representante de ventas.',
  'Search clinics...': 'Buscar clínicas...',
  'Hub views': 'Vistas del centro',
  'Team': 'Equipo',

  // Summary strip
  'Ordering on': 'Pedidos activados',
  'Limited products': 'Productos limitados',
  'Past due': 'Con saldo vencido',

  // Clinic card
  '1 login': '1 inicio de sesión',
  '{n} logins': '{n} inicios de sesión',
  'Ordering': 'Envío de pedidos',
  'On': 'Activado',
  'Off · read-only': 'Solo lectura',
  '{n} of {total}': '{n} de {total}',
  '{n} product': '{n} producto',
  '{n} products': '{n} productos',
  'No products in the catalog.': 'No hay productos en el catálogo.',
  'Credit': 'Crédito',
  '{outstanding} of {limit}': '{outstanding} de {limit}',
  'No limit set': 'Sin límite establecido',
  '1 past due': '1 factura vencida',
  '{n} past due': '{n} facturas vencidas',
  'Last changed by {name}, {date}': 'Último cambio por {name}, {date}',
  'Manage': 'Administrar',

  // Clinic-login details panel
  'What your clinic can do': 'Lo que su clínica puede hacer',
  'Your clinic can submit orders.': 'Su clínica puede enviar pedidos.',
  'Ordering is turned off for your clinic. Your sales representative places orders for you.':
    'El envío de pedidos está desactivado para su clínica. Su representante de ventas realiza los pedidos por usted.',
  'All products': 'Todos los productos',
  'Credit limit': 'Límite de crédito',
  'Available': 'Disponible',

  // Empty, no-match and error states
  'No clinic is linked to your login yet.': 'Aún no hay ninguna clínica vinculada a su inicio de sesión.',
  'No clinics are assigned to you yet.': 'Aún no tiene clínicas asignadas.',
  'An administrator assigns clinics on the Sales Representatives page.':
    'Un administrador asigna las clínicas en la página Representantes de ventas.',
  'No clinics match your search.': 'Ninguna clínica coincide con su búsqueda.',
  'Could not load your clinics': 'No se pudieron cargar sus clínicas',

  // Server sentences the hub endpoints return (err.response.data.error)
  'Ordering is turned off for this clinic. Ask your MedEffects sales representative to place the order.':
    'El envío de pedidos está desactivado para esta clínica. Pida a su representante de ventas de MedEffects que realice el pedido.',
  'You can only change settings for clinics assigned to you.':
    'Solo puede cambiar la configuración de las clínicas que tiene asignadas.',
  'Pick at least one product, or choose "All products".':
    'Elija al menos un producto o seleccione "Todos los productos".',
  'One or more of those products do not exist or are no longer active. Refresh the list and try again.':
    'Uno o más de esos productos no existen o ya no están activos. Actualice la lista e inténtelo de nuevo.',
  'Clinic not found': 'Clínica no encontrada',
};

export default hub;
